export const vestingContractAddress =
  process.env.VUE_APP_VESTING_CONTRACT_ADDRESS;
export const bluesAddress = String(process.env.VUE_APP_BLUES_ADDRESS);
export const bluesDecimals = Number(process.env.VUE_APP_BLUES_DECIMALS);
export const apiBaseUrl = process.env.VUE_APP_BACKEND_URL;
export const usdTokenAddress = process.env.VUE_APP_USD_TOKEN_ADDRESS;
export const usdTokenDecimals = Number(process.env.VUE_APP_USD_TOKEN_DECIMALS);
